import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { PublicWebsiteNav } from './index';
import { fetchStatus } from '../../money';

class PublicWebsiteNavWrapper extends React.Component {
  state = { isMobileNavVisible: false };

  componentDidMount() {
    const { fetchMoneyStatus, user } = this.props;
    if (user) {
      fetchMoneyStatus();
    }
  }

  toggleMobileNavVisible = () => {
    const { isMobileNavVisible } = this.state;
    if (isMobileNavVisible) {
      document.body.classList.remove('lockScroll');
    } else {
      document.body.classList.add('lockScroll');
    }
    this.setState({ isMobileNavVisible: !isMobileNavVisible });
  };

  render() {
    const { isMobileNavVisible } = this.state;
    const {
      campaigns,
      isAllowedToSeeMoneyNavItem,
      onLogOut,
      user,
      podcastNetwork,
      onClickNavItem,
      pathname,
      podcastName,
      podcastImage,
    } = this.props;
    return (
      <PublicWebsiteNav
        pathname={pathname}
        isAllowedToSeeMoneyNavItem={isAllowedToSeeMoneyNavItem}
        user={user}
        onLogOut={onLogOut}
        podcastNetwork={podcastNetwork}
        onClickNavItem={onClickNavItem}
        campaigns={campaigns}
        toggleMobileWebsiteNavVisible={this.toggleMobileNavVisible}
        isMobileNavVisible={isMobileNavVisible}
        podcastName={podcastName}
        podcastImage={podcastImage}
      />
    );
  }
}

PublicWebsiteNavWrapper.propTypes = {
  isAllowedToSeeMoneyNavItem: PropTypes.bool.isRequired,
  onLogOut: PropTypes.func.isRequired,
  user: PropTypes.shape({
    imageUrl: PropTypes.string,
    userId: PropTypes.number,
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  podcastNetwork: PropTypes.bool,
  onClickNavItem: PropTypes.func.isRequired,
  campaigns: PropTypes.arrayOf(
    PropTypes.shape({
      campaignStatus: PropTypes.string,
    })
  ),
  pathname: PropTypes.string,
  podcastName: PropTypes.string,
  podcastImage: PropTypes.string,
};

PublicWebsiteNavWrapper.defaultProps = {
  podcastNetwork: null,
  user: null,
  campaigns: [],
  pathname: null,
  podcastName: null,
  podcastImage: null,
};

const PublicWebsiteNavContainer = connect(
  null,
  dispatch => ({
    fetchMoneyStatus: () => dispatch(fetchStatus()),
  })
)(PublicWebsiteNavWrapper);

export { PublicWebsiteNavContainer };
